import request from '@/utils/request'

export function list(data) {
  return request({
    module: 'center',
    url: '/server/list',
    method: 'post',
    data: data
  })
}

export function getFullUrl(data) {
  return request({
    module: 'center',
    url: '/server/getFullUrl/' + data,
    method: 'get'
  })
}

export function listWithHostInfo(data) {
  return request({
    module: 'center',
    url: '/server/host/list',
    method: 'post',
    data: data
  })
}

export function edit(id) {
  return request({
    module: 'center',
    url: '/server/' + id,
    method: 'get'
  })
}

export function save(data) {
  return request({
    module: 'center',
    url: '/server/save',
    method: 'post',
    data: data
  })
}

export function del(data) {
  return request({
    module: 'center',
    url: '/server/delete',
    method: 'post',
    data: data
  })
}

export function getDataDistribution(data) {
  return request({
    module: 'center',
    url: '/server/getDataDistribution',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/center/server.js